import * as React from 'react'
import { connect } from 'react-redux'
import { ApplicationState, ConnectedReduxProps } from '../../store'
import { Flickr, FlickrState } from '../../store/flickr/types'
import { fetchRequest } from '../../store/flickr/actions'
import styled, { Theme } from '../../utils/styled'
import LottieLoading from '../../components/data/LottieLoading'
import { Dispatch } from 'redux'

// Separate state props + dispatch props to their own interfaces.
interface PropsFromState {
  loading: boolean
  data: Flickr[]
  errors?: string
}
// We can use `typeof` here to map our dispatch types to the props, like so.
interface PropsFromDispatch {
  fetchRequest: typeof fetchRequest
}

interface FlickrProps {
  search: string
}

interface State {
  selected?: Flickr
}
// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch & FlickrProps & ConnectedReduxProps

class FlickrGallery extends React.Component<AllProps, State> {
  constructor(props: AllProps) {
    super(props)
    // this.state = { search: '72157627491430747', selected: undefined }
  }
  public componentDidMount() {
    const { data } = this.props
    if (!data || data.length === 0) {
      console.log('FlickrGallery', this.props)
      this.props.fetchRequest(this.props.search)
    }
  }

  render() {
    const { data, loading, errors } = this.props
    return (
      <div>
        <div id="container">
          <h1>Flickr Search</h1>
        </div>
        <div id="error">
          <p>{errors}</p>
        </div>
        <div id="results">
          {/* {
            data ?
            (
              data.map((item, index) => (
                <div id="image">
                  <img src={item.media.m} />
                </div>
              ))
            )
            :
              data!=undefined && errors == ''?
                <div id="empty">
                  <p> No results </p>
                </div>
              :
                <div />
          } */}
        </div>
      </div>
    )
  }
}
const mapStateToProps = ({ flickr }: ApplicationState) => ({
  loading: flickr.loading,
  errors: flickr.errors,
  data: flickr.data
})

// mapDispatchToProps is especially useful for constraining our actions to the connected component.
// You can access these via `this.props`.
const mapDispatchToProps = (dispatch: Dispatch) => ({
  fetchRequest: (search: string) => dispatch(fetchRequest(search))
})

// Now let's connect our component!
// With redux v4's improved typings, we can finally omit generics here.
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FlickrGallery)
